export const ORG_ID = process.env.ORG_ID || 'vontravel';
export const STRIPE_CLIENT_KEY =
  process.env.STRIPE_CLIENT_KEY || 'pk_test_4TIFMOIsOk7nGH6fx0YL8e4h00VHfSXKoX';
export const AUTH_TOKEN = 'auth:token';
export const GOOGLE_MAP_SEARCH_URL = 'https://www.google.com/maps/search/';
